import React from 'react';
import ReactDOM from 'react-dom';
import * as serviceWorker from './common/serviceWorker';
import App from './App';
import { Provider } from 'react-redux';
import configureStore from './store/config';
import { CookiesProvider } from 'react-cookie';
import { Router } from 'react-router-dom';
import { createBrowserHistory } from 'history';

const { store } = configureStore();
const browserHistory = createBrowserHistory();

const app = (
  <CookiesProvider>
    <Provider store={store}>
      <Router history={browserHistory}>
        <App />
      </Router>
    </Provider>
  </CookiesProvider>
);

ReactDOM.render(app, document.getElementById('root'));

serviceWorker.unregister();
